// Time units
export const MINUTES_PER_HOUR = 60;
export const MINUTES_PER_DAY = MINUTES_PER_HOUR * 24;

// Tick mark generation thresholds and step sizes (in minutes)
export const HALF_HOUR_TICK_THRESHOLD = 4 * MINUTES_PER_HOUR;
export const TWO_HOUR_TICK_THRESHOLD = 10 * MINUTES_PER_HOUR;
export const TICK_STEP_HALF_HOUR = 30;
export const TICK_STEP_HOUR = MINUTES_PER_HOUR;
export const TICK_STEP_TWO_HOURS = 2 * MINUTES_PER_HOUR;

// Slider thumb diameter
export const THUMB_SIZE = "0.8125rem";

// Default selected duration when the picker initializes or is reset (minutes).
export const DEFAULT_SELECTION_MINUTES = MINUTES_PER_HOUR;
